
import { defineComponent, ref } from 'vue'
import StoryblokClient from 'storyblok-js-client'
import Brand from '@/components/Brand.vue'

const storyapi = new StoryblokClient({
  accessToken: process.env.VUE_APP_API_TOKEN
})

export default defineComponent({
  components: {
    Brand
  },
  setup () {
    const story = ref({
      content: {
        body: [
          {
            component: ''
          }
        ]
      }
    })

    return {
      story
    }
  },
  methods: {
    getStory (slug: string) {
      storyapi.get('cdn/stories/' + slug)
        .then((response) => {
          this.story = response.data.story
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  created () {
    window.storyblok.init({
      accessToken: process.env.VUE_APP_API_TOKEN
    })
    window.storyblok.on('change', () => {
      this.getStory('brands')
    })
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        this.getStory('brands')
      } else {
        this.getStory('brands')
      }
    })
  }
})
